import { LegalLayout } from "../components/site/LegalLayout";

const sections = [
  {
    id: "who",
    number: "01",
    title: "Who can use ProBeauty Connect",
    content: (
      <ul>
        <li>You must be at least 16 years old.</li>
        <li>If you sign up as a professional, you represent that you hold a valid beauty/cosmetology/barbering license in the state listed on your profile.</li>
        <li>If you sign up as a business owner, you represent that you have authority to post hiring listings for the business.</li>
      </ul>
    ),
  },
  {
    id: "account",
    number: "02",
    title: "Your account",
    content: (
      <ul>
        <li>Keep your password confidential.</li>
        <li>You are responsible for activity on your account.</li>
        <li>Notify us immediately of unauthorized use: <a href="mailto:security@probeauty.app">security@probeauty.app</a>.</li>
      </ul>
    ),
  },
  {
    id: "post",
    number: "03",
    title: "What you can post",
    content: (
      <>
        <p>You retain ownership of content you post (listings, applications, messages, photos). By posting, you grant ProBeauty Connect a worldwide, non-exclusive, royalty-free license to display that content within the App and related services.</p>
        <p><strong>You agree NOT to post:</strong></p>
        <ul>
          <li>False or misleading licenses, certifications, or business information.</li>
          <li>Discriminatory hiring criteria that violate equal-opportunity laws.</li>
          <li>Off-platform contact info designed to bypass the marketplace (no “DM me on Instagram to apply”).</li>
          <li>Harassing, threatening, sexually explicit, or otherwise unlawful content.</li>
          <li>Spam, scams, multi-level marketing, or non-beauty-industry job postings.</li>
        </ul>
      </>
    ),
  },
  {
    id: "payments",
    number: "04",
    title: "Payments & subscriptions",
    content: (
      <ul>
        <li>Listing Boosts and Verified Pro subscriptions are sold through Apple In-App Purchase (iOS) and Google Play Billing (Android). All billing, refund, and dispute handling follows Apple's/Google's terms.</li>
        <li>Boosts are consumable — they expire at the end of the purchased duration.</li>
        <li>Verified Pro is an auto-renewing subscription — it renews automatically until you cancel via iOS Settings → Subscriptions or the Google Play Store.</li>
        <li>Refunds: contact Apple or Google support. ProBeauty Connect cannot directly refund IAP purchases.</li>
        <li>Credits earned via referrals can be applied to Listing Boosts only and have no cash value.</li>
      </ul>
    ),
  },
  {
    id: "verification",
    number: "05",
    title: "License verification",
    content: (
      <p>Professionals must submit a license photo and details. Verification is performed by our admin team. We may approve, reject, or request resubmission. Verification is not a guarantee of license validity — owners are encouraged to independently verify before hiring.</p>
    ),
  },
  {
    id: "conduct",
    number: "06",
    title: "Marketplace conduct",
    content: (
      <p>ProBeauty Connect is a venue connecting professionals and owners. We are not a party to any employment or rental agreement between users. Wages, terms, taxes, insurance, and labor compliance are between the parties.</p>
    ),
  },
  {
    id: "termination",
    number: "07",
    title: "Termination",
    content: (
      <p>We may suspend or terminate accounts that violate these Terms or applicable law, with or without notice. You may delete your account anytime via <a href="/delete-account">Delete Your Account</a> or in-app.</p>
    ),
  },
  {
    id: "disclaimers",
    number: "08",
    title: "Disclaimers & limitation of liability",
    content: (
      <p>The App is provided “as is.” To the maximum extent permitted by law, we disclaim warranties of merchantability, fitness for purpose, and non-infringement. Our total liability for any claim arising from the App is limited to the amount you paid to us in the 12 months before the claim, or USD $100, whichever is greater.</p>
    ),
  },
  {
    id: "law",
    number: "09",
    title: "Governing law",
    content: (
      <p>These Terms are governed by the laws of the State of California, USA, without regard to conflict of laws principles. Disputes will be resolved in the courts of San Francisco County, California, except where prohibited by local law.</p>
    ),
  },
  {
    id: "changes",
    number: "10",
    title: "Changes",
    content: (
      <p>We may revise these Terms. Material changes are announced via in-app notification. Continued use after changes constitutes acceptance.</p>
    ),
  },
  {
    id: "contact",
    number: "11",
    title: "Contact",
    content: (
      <>
        <p><strong>Legal & Support</strong></p>
        <p>Email: <a href="mailto:legal@probeauty.app">legal@probeauty.app</a><br />Support: <a href="mailto:support@probeauty.app">support@probeauty.app</a></p>
      </>
    ),
  },
];

export default function TermsOfService() {
  return (
    <LegalLayout
      eyebrow="ProBeauty Connect"
      titleLines={["Terms of", "Service"]}
      meta="Effective Date: May 29, 2026"
      intro="Welcome to ProBeauty Connect. By creating an account or using the App, you agree to these Terms. Please read them carefully."
      sections={sections}
    />
  );
}
